<script setup>
    import {computed, ref} from 'vue'
    import SidebarNavigationSubItem from "./sidebarNavigationSubItem.vue";

    const props = defineProps({
        item: {
            type: Object,
            required: true
        },
        isFirst: {
            type: Boolean,
            required: false,
            default: false
        },
        isLast: {
            type: Boolean,
            required: false,
            default: false
        },
        notificationCount: {
            type: Number,
            required: false,
            default: 0,
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
    })

    const topLevelItem = ref(null)

    const toggleExpanded = () => {
        isExpanded.value = !isExpanded.value
    }
    const isExpanded = ref(false)

    const notificationCountClass = computed(() => {
        const classes = [];

        if (props.notificationCount > 0) {
            classes.push('scale-100');
        } else {
            classes.push('scale-0 opacity-0');
        }

        if (props.notificationCount > 1) {
            if (props.notificationCount > 99) {
                classes.push('w-5 h-4 border-2 border-brandPrimary-500 top-2 -right-2.5');
            } else {
                classes.push('w-4 h-4 border-2 border-brandPrimary-500 top-2 -right-2');
            }
        } else {
            classes.push('w-3 h-3 top-3 -right-1.5');
        }

        return classes.join(' ');
    })

    const isActive = computed(() => {
        let active = false
        if (route().current(props.item.routeName, props.item.routeParams)) {
            active = true
        }
        props.item.subItems?.forEach(subItem => {
            if(route().current(subItem.routeName, subItem.routeParams)) {
                active = true
            }
        })
        props.item.activeRoutes?.forEach(subItem => {
            if(route().current(subItem, props.item.routeParams)) {
                active = true
            }
        })
        return active
    })

</script>
<template>
    <li
        v-if="Object.keys(item).length > 0"
        class="relative group -ml-2 pl-7 pr-3"
        :class="isActive ? '' : ''"
    >
        <div
            class="relative flex justify-between items-center group"
        >
            <div
                :class="notificationCountClass"
                class="absolute z-10 flex items-center justify-center overflow-hidden leading-none transition-all rounded-full cursor-default bg-brandPrimary-500 text-white"
                style="font-size: 8px;"
            >
                {{ notificationCount === 1 ? '' : notificationCount }}
            </div>
            <a
                :href="item.active ? item.href : '#'"
                :aria-current="isActive ? 'page' : undefined"
                class="py-1 px-2 flex flex-1 space-x-1 items-start transition-colors duration-150 relative border border-transparent rounded-md"
                :class="[item.active ? 'hover:bg-gray-50 hover:border-gray-100' : '', isActive ? 'bg-myflowLavender-light border-myflowLavender' : '']"
                :data-coming-soon="item.comingSoon"
            >
                <div>
                    <div
                        class="text-xs pt-0.5 font-medium tracking-tight"
                        :class="[item.comingSoon ? 'text-gray-400 cursor-default' : '']"
                    >
                        {{ _mft(item.name) }}
                    </div>
                    <div
                        v-if="(!isExpanded) && item.byline"
                        class="pr-2 -mt-0.5 text-xxs"
                        :class="item.comingSoon ? 'text-gray-300 cursor-default' : 'text-gray-400'"
                    >
                        {{ _mft(item.byline) }}
                    </div>
                </div>
            </a>
        </div>
        <ul
            v-if="item.active"
        >
            <SidebarNavigationSubItem
                v-for="item in item.subItems"
                v-bind:key="item.name"
                :item="item"
            />

            <li
                v-if="item.primaryCallToAction"
                class="absolute top-0 right-4 opacity-0 -translate-x-4 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-100"
            >
                <a
                    :href="item.primaryCallToAction.href"
                    class="relative z-30 block text-xs w-full"
                >
                    <button-primary
                        size="xs"
                        class="justify-center -ml-1 mt-1"
                    >
                        {{ _mft(item.primaryCallToAction.name) }}
                    </button-primary>
                </a>
            </li>
        </ul>
    </li>
</template>
